<script setup lang="ts">
  import type { ReferenceSectionData } from '@/models/reference';
  import type { PropType } from 'vue';
  import { useReferences } from '@/composables/useReferences';
  import ReferenceCard from '@/components/references/ReferenceCard.vue';

  const props = defineProps({
    referenceSectionData: {
      type: Object as PropType<ReferenceSectionData>,
      required: true
    }
  });

  const {
    swiperRef,
    fixedWidthOnLg,
    fixedWidthOnSm,
    fixedWidthOnMd,
    shouldHideButtons,
    shouldDisableNext,
    shouldDisablePrev,
    isInitialized,
    onSlideChange,
    next,
    prev
  } = useReferences(props.referenceSectionData.references);
</script>

<template>
  <section class="references-section">
    <div class="container">
      <div class="references-section__wrapper">
        <h3
          class="references-section__heading"
          v-html="referenceSectionData.heading"></h3>
        <div class="references-section__swiper">
          <div
            v-if="!shouldHideButtons"
            :class="['references-section__btn references-section__btn--prev', { 'references-section__btn--disabled': shouldDisablePrev }]"
            @click.prevent.stop="prev" />
          <swiper-container
            ref="swiperRef"
            slides-per-view="auto"
            :space-between="0"
            :loop="false"
            :speed="1000"
            :init="false"
            :class="[
              'references-section__swiper-container',
              { 'references-section__swiper-container--center': shouldHideButtons },
              { 'swiper-initialized': isInitialized }
            ]"
            @swiperslidechange="onSlideChange()">
            <swiper-slide
              v-for="(reference, index) in referenceSectionData.references"
              :key="index"
              :class="['references-section__swiper-item', { '--lg-fix': fixedWidthOnLg, '--md-fix': fixedWidthOnMd, '--sm-fix': fixedWidthOnSm }]">
              <ReferenceCard :reference="reference" />
            </swiper-slide>
          </swiper-container>
          <div
            v-if="!shouldHideButtons"
            :class="['references-section__btn references-section__btn--next', { 'references-section__btn--disabled': shouldDisableNext }]"
            @click.prevent.stop="next" />
        </div>
      </div>
    </div>
  </section>
</template>
